export default __webpack_public_path__ + "static/media/old_logo.a4769db3.jpg";